import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class Profit {
  // 利润统计列表
  static getProfitList(options) {
    let url = `/zwy/api/cb/logistics/bill/statistic/order/profit?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //导出
  static getExportExcel(options) {
    let url = `/zwy/api/cb/logistics/bill/download/order/profit?`;
    url += handleGetRequestParams(options)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default Profit;
